import FrontPage from "./Views/FrontPage";

const App = () => {

    return (<FrontPage/>)
};

export default App;
